<template>
  <div id="main">
    <el-container>
      <el-header>
        <div style="margin-top: 15px;width: 100%;height: 100%;background-color:#529BEB;padding-top: 15px">
          <el-row :gutter="18">
            <el-col :span="3">
              <div class="grid-content bg-purple" style=" background-color:#529BEB;  text-align: center">
                <p style="color: white;font-size: 20px;">快速检索</p>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bg-purple" style="background-color:#529BEB">
                <el-select v-model="department" clearable placeholder="选择部门" size="mini">
                  <el-option
                      v-for="(value,index) in deptList"
                      :key="index"
                      :label="value"
                      :value="value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple" style="background-color:#529BEB">
                <el-input placeholder="请输入要检索的邮箱" size="mini" v-model="email" class="input-with-select"
                          clearable></el-input>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bg-purple" style="background-color:#529BEB">
                <el-select v-model="role" clearable placeholder="角色" size="mini">
                  <el-option
                      v-for="(role,index) in roleList"
                      :key="index"
                      :label="role.roleName"
                      :value="role.roleName">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple" style="background-color:#529BEB;float: right ">
                <el-button icon="el-icon-search" size="small" circle
                           @click="searchUser(department,email,role)"></el-button>
                <el-button icon="el-icon-refresh" size="small" circle @click="refresh"></el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-container>
        <el-main>
          <template>
            <el-table
                :data="showList"
                style="height:100%;width:100%"
                border
                stripe>
              <el-table-column
                  prop="userName"
                  label="用户邮箱"
                  min-width="15%">
              </el-table-column>
              <el-table-column
                  prop="roleName"
                  label="角色名"
                  min-width="50%">
                <template slot-scope="scope">
                  <span v-for="(value,index) in showList[scope.$index].roleName" :key="index"
                        style="margin-right:10px;">
                    {{value}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="status"
                  label="状态"
                  min-width="10%">
              </el-table-column>
              <el-table-column
                  label="操作"
                  min-width="25%">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">分配</el-button>
                  <el-popover
                      ref="popover1"
                      placement="left"
                      width="310"
                      trigger="click"
                      @show="getControlDevice(scope.$index, scope.row)">
                    <el-table :data="controlDevice">
                      <el-table-column width="150" property="deviceName" label="设备名字"></el-table-column>
                      <el-table-column width="130" property="name" label="操作"></el-table-column>
                    </el-table>
                    <el-button slot="reference" size="mini">可控设备</el-button>
                  </el-popover>
                  <el-popover
                      ref="popover2"
                      placement="left"
                      width="310"
                      trigger="click"
                      @show="getControlProject(scope.$index, scope.row)">
                    <el-table :data="controlProject">
                      <el-table-column width="150" property="projectName" label="项目名字"></el-table-column>
                      <el-table-column width="130" property="name" label="操作"></el-table-column>
                    </el-table>
                    <el-button slot="reference" size="mini">可看项目</el-button>
                  </el-popover>
                </template>
                <!--                分配窗口-->
                <el-dialog
                    title='分配'
                    :visible.sync="dialogVisible"
                    width="50%"
                    :append-to-body="true">
                  <el-tabs v-model="activeName">
                    <el-tab-pane label="分配角色">
                      <span style="font-size:15px">分配用户{{editRole.userName}}的角色:</span>
                      <el-card class="box-card" style="margin: 8px">
                        <el-checkbox-group v-model="editRole.roleName">
                          <el-checkbox
                              v-for="(role,index) in roleList"
                              :key="index"
                              :label="role.roleName"
                              style="margin-right: 10px">
                          </el-checkbox>
                        </el-checkbox-group>
                      </el-card>
                      <el-button type="primary" @click=roleBind style="margin: 8px;float: right">确 定</el-button>
                      <el-button @click="dialogVisible = false" style="margin: 8px;float: right">取 消</el-button>
                    </el-tab-pane>
                    <el-tab-pane label="分配设备">
                      <span style="font-size:15px">分配用户{{editRole.userName}}的设备:</span>
                      <el-card class="box-card" style="margin: 8px">
                        <el-checkbox-group v-model="editDeviceList">
                          <el-checkbox
                              v-for="(device,index) in deviceList"
                              :key="index"
                              :label="device.name"
                              style="margin-right: 10px">
                          </el-checkbox>
                        </el-checkbox-group>
                      </el-card>
                      <el-button type="primary" @click=deviceBind style="margin: 8px;float: right">确 定</el-button>
                      <el-button @click="dialogVisible = false" style="margin: 8px;float: right">取 消</el-button>
                    </el-tab-pane>
                    <el-tab-pane label="分配项目">
                      <span style="font-size:15px">分配用户{{editRole.userName}}的项目:</span>
                      <el-card class="box-card" style="margin: 8px">
                        <el-checkbox-group v-model="editProjectList">
                          <el-checkbox
                              v-for="(project,index) in projectList"
                              :key="index"
                              :label="project.name"
                              style="margin-right: 10px">
                          </el-checkbox>
                        </el-checkbox-group>
                      </el-card>
                      <el-button type="primary" style="margin: 8px;float: right">确 定</el-button>
                      <el-button @click="dialogVisible = false" style="margin: 8px;float: right">取 消</el-button>
                    </el-tab-pane>
                  </el-tabs>
                </el-dialog>
              </el-table-column>
            </el-table>
          </template>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import {mapActions, mapState, mapGetters} from 'vuex'
  import authority from "../../api/authority";

  export default {
    data() {
      return {
        role: '',
        department: '',
        email: '',
        showList: [],
        activeName: '0',
        dialogVisible: false,
        editRole: {},
        roleId: [],
        controlDevice: [],
        controlProject: [],
        //以下为测试变量
        editProjectList: [],
        editDeviceList: [],
        userDeviceList: [],
        deviceId: [],
      };
    },
    mounted() {
      //获取用户信息
      this.getUserList().catch((err) => {
        this.$message.error(`用户查询失败 (${err[0]})：${err[1]}`)
      })
      //这里获取部门信息无效？原因为当时还未得到用户信息数组
      //获取角色信息
      this.getRoleList().catch((err) => {
        this.$message.error(`角色信息获取失败 (${err[0]})：${err[1]}`)
      })
      //获取设备信息
      this.getDeviceList().catch((err) => {
        this.$message.error(`设备信息获取失败 (${err[0]})：${err[1]}`)
      })
      //获取项目信息
      this.getProjectList().catch((err) => {
        this.$message.error(`项目信息获取失败 (${err[0]})：${err[1]}`)
      })
    },
    methods: {
      ...mapActions('Authority', ['getUserList', 'getRoleList', 'getDeviceList', 'getProjectList']),
      //检索
      searchUser(department, email, role) {
        this.showList = this.userList
        if (department === '' && email === '' && role === '') {
          this.$message('请输入检索内容')
        } else {
          if (department !== '') {
            this.showList = this.userList.filter(user => {
              return user.deptName === department
            })
          }
          if (email !== '') {
            this.showList = this.showList.filter(user => {
                return user.userName === email
              }
            )
          }
          if (role !== '') {
            this.showList = this.showList.filter(user => {
                return user.roleName.indexOf(role) !== -1
              }
            )
          }
          if (this.showList.length === 0) {
            this.$message('不存在该用户，请重新查询')
            this.showList = this.userList
          }
        }
      },
      //重置
      refresh() {
        this.department = ''
        this.email = ''
        this.role = ''
        this.showList = this.userList
      },
      //分配
      handleEdit(index, row) {
        this.dialogVisible = true
        this.editRole = Object.assign({}, row)
        this.getUserDeviceList(index, row)
      },
      //生成roleId
      getRoleId(roleList) {
        this.roleId = []
        for (let i1 = 0; i1 < roleList.length; i1++) {
          for (let i2 = 0; i2 < this.roleList.length; i2++) {
            if (roleList[i1] === this.roleList[i2].roleName) {
              this.roleId.push(this.roleList[i2].roleId)
            }
          }
        }
      },
      //查询可控设备
      getControlDevice(index, row) {
        this.editRole = Object.assign({}, row)
        this.controlDevice = []
        const userId = this.editRole.id
        const url = `/user/controlDevice/${userId}`
        authority.controlDevice(url).then((res) => {
          res.map((item) => {
            this.controlDevice.push(item)
          })
        }).catch((err) => {
          this.$message.error(`用户可控设备查询失败 (${err[0]})：${err[1]}`)
        })
      },
      //查询可控项目
      getControlProject(index, row) {
        this.editRole = Object.assign({}, row)
        this.controlProject = []
        const userId = this.editRole.id
        const url = `/user/controlProject/${userId}`
        authority.controlProject(url).then((res) => {
          res.map((item) => {
            this.controlProject.push(item)
          })
        }).catch((err) => {
          this.$message.error(`用户可控项目查询失败 (${err[0]})：${err[1]}`)
        })
      },
      //查询用户的设备列表
      getUserDeviceList(index, row) {
        this.userDeviceList = []
        const userId = this.editRole.id
        const url = `/user/deviceList/${userId}`
        authority.getUserDeviceList(url).then((res) => {
          res.map((item) => {
            this.userDeviceList.push(item)
          })
        }).catch((err) => {
          this.$message.error(`用户设备查询失败 (${err[0]})：${err[1]}`)
        })
      },
      //角色分配
      roleBind() {
        this.dialogVisible = false
        this.getRoleId(this.editRole.roleName)
        const userId = this.editRole.id
        const roleId = this.roleId
        authority.userBindRole(userId, roleId).then((res) => {
          this.$message({
            type: 'success',
            message: '角色分配成功',
          });
          this.roleId = []
        }).catch((err) => {
          this.$message.error(`角色分配失败 (${err[0]})：${err[1]}`)
        })
        //刷新用户列表
        this.getUserList().catch((err) => {
          this.$message.error(`用户查询失败 (${err[0]})：${err[1]}`)
        })
      },
      //设备分配
      //11-06修改为每次分配一个设备，后续待修复
      deviceBind() {
        this.dialogVisible = false
        // this.deviceId = []
        this.deviceId=''
        for (let i1 = 0; i1 < this.editDeviceList.length; i1++) {
          for (let i2 = 0; i2 < this.deviceList.length; i2++) {
            if (this.editDeviceList[i1] === this.deviceList[i2].name) {
              // this.deviceId.push(this.deviceList[i2].id)
              this.deviceId=this.deviceList[i2].id
            }
          }
        }
        const userId = this.editRole.id
        const deviceList = this.deviceId
        console.log(userId, deviceList)
        authority.deviceAllocate(userId, deviceList).then((res) => {
          this.$message({
            type: 'success',
            message: '设备分配成功',
          });
          this.deviceId = []
        }).catch((err) => {
          this.$message.error(`设备分配失败 (${err[0]})：${err[1]}`)
        })
      }
    },
    computed: {
      ...mapState('Authority', ['userList', 'roleList', 'deviceList', 'projectList']),
      ...mapGetters('Authority', ['deptList']),
    },
    watch: {
      userList: {
        deep: true,
        handler: function () {
          this.showList = this.userList
        },
      },
      userDeviceList: function () {
        this.editDeviceList = []
        for (let i = 0; i < this.userDeviceList.length; i++) {
          this.editDeviceList.push(this.userDeviceList[i].deviceName)
        }
      }
    }
  }
</script>
<style scoped>
  * {
    margin: 0px 0px 0px 0px;
  }

  .el-header {
    line-height: 10%;
    height: 5%;
    margin-bottom: 5px;
  }

  .el-footer {
    line-height: 5%;
    height: 5%;
  }

  .el-main {
    text-align: center;
    line-height: 160px;
    /*设置高度会导致下方无法显示滚动条*/
    height: 100%;
  }

  .el-container {
    /*会导致显示异常*/
    /*height: 100%;*/
    width: 100%;
  }

  #main {
    height: 100%;
    width: 100%;
    background-color: #F9F9F9;
  }


  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>



// WEBPACK FOOTER //
// src/components/authority/userSelect.vue